import {Component, OnInit, OnDestroy, ViewChild, Input, Output, EventEmitter} from '@angular/core';
import {EnvService} from "../../services/env.service";
import {HttpClient, HttpParams} from "@angular/common/http";
import {AuthService} from "../../services/auth.service";
import {MatLegacyTableDataSource as MatTableDataSource} from "@angular/material/legacy-table";
import {MatLegacyPaginator as MatPaginator} from "@angular/material/legacy-paginator";
import {SiteFilter} from "./site.filter";
import { debounceTime } from 'rxjs/operators';
import {SettingsPersistenceService} from "../../services/settings-persistence.service";

@Component({
  selector: 'micro-sites',
  templateUrl: './sites.component.html'
})
export class SitesComponent implements OnInit, OnDestroy  {

  dataSource:MatTableDataSource<any> = new MatTableDataSource<any>();
  filter:SiteFilter = new SiteFilter();

  @Input()
  selectionMode:string;

  @Input()
  selectedRow:any;

  @Output()
  selectedRowChange:EventEmitter<any> = new EventEmitter<any>();

  @ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;

  pageSettings: SettingsPersistenceService;

  get embedded(): boolean {
    return !!this.selectionMode;
  }

  constructor(public auth:AuthService, private env:EnvService, private http:HttpClient) {
  }

  onSelectedRowChange() {
    this.selectedRowChange.emit(this.selectedRow);
  }

  ngOnInit() {
    this.pageSettings = new SettingsPersistenceService(sessionStorage, "micro.sites");
    this.pageSettings
      .setFilter(this.filter)                       // page filter object
      .setPaginator(this.paginator)                 // page paginator object
      .setEmbedded(this.embedded)            // if true, the service will not save settings to storage
      .setEmbeddedFilterProps({})
      .init();

    this.filter.anyChange.pipe(debounceTime(500)).subscribe(change => {
      this.reload();
    });

    this.reload();
  }

  ngOnDestroy() {
  }

  reload() {
    let params:HttpParams = this.filter.getParams()
        .set("page", '' + (this.paginator.pageIndex || 0))
        .set("size", '' + (this.paginator.pageSize || this.pageSettings.defaultPageSize))
      ;

    this.http.get(`${this.env.e.url}/domain/sites`, {params: params}).subscribe(
      data => {
        let page = data as any;
        this.dataSource.data = page.content;
        this.paginator.pageIndex = page.number;
        this.paginator.length = page.totalElements;
      }
    );
  }
}
